import { render } from "./PraticaSubentro.vue?vue&type=template&id=e8b1b9be&scoped=true"
import script from "./PraticaSubentro.vue?vue&type=script&lang=js"
export * from "./PraticaSubentro.vue?vue&type=script&lang=js"

import "./PraticaSubentro.vue?vue&type=style&index=0&id=e8b1b9be&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8b1b9be"]])

export default __exports__